<div class="da_p_workspace">
  <div class="row heading-background mt-5">

    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
      <h4>
        <span
          class ="clickable-cursor"
          [ngClass]="showData ? 'rotated' : 'not-rotated'"
          (click)="showData ? hideData() : resetAll()"
          role="button">
          <mat-icon class="icon-color-fix ump-expand-section-icon">chevron_right</mat-icon>
        </span>
        <span
          (click)="showData ? hideData() : onClickLoad()"
          role="button"
          class ="clickable-cursor">
          Data Analytics and PowerBI Workspaces
        </span>
        @if (defaults.stage === 1 && defaults.isPBIWorkspaceCreatorUser && showData) {
          <button class="button-color-fix_white" mat-mini-fab="" title="Create new PBI Workspace" (click)="openPowerbiWorkspacePopup()">
            <span class="mat-button-wrapper" style="padding:0px;" itle="Search users">
              <mat-icon role="img" style="font-size:20px !important;height:20px !important; width:20px !important"
              aria-hidden="true" data-mat-icon-type="font">add</mat-icon>
              <span class="mat-button-ripple mat-ripple mat-button-ripple-round"
                matripple="">
              </span>
              <span class="mat-button-focus-overlay"></span>
            </span>
          </button>
        }
      </h4>
    </div>

    @if (showData) {
      <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 search-container">
        <button mat-raised-button (click)="funcGetUserDataAnlytics(true)" [disabled]="Tree_Response_State === -3" aria-label="Reset" class="btn btn-sm button-fix button-color-fix-orange">
          <mat-icon class="icon-color-fix">cached</mat-icon>
        </button>
        <input class="form-control" [(ngModel)]="searchString" [disabled]="Tree_Response_State === -3" type="text" (keyup)="longTreeExpandAll()" placeholder="Search" />
        <mat-slide-toggle matTooltip="Show only selected" [disabled]="Tree_Response_State === -3" class="toggle-show-only-selected" [(ngModel)]="showOnlySelected"></mat-slide-toggle>
        <button aria-label="Collapse All" [disabled]="Tree_Response_State === -3" class="btn btn-sm button-fix button-color-fix-orange " (click)="treeControl.collapseAll()">
          <mat-icon class="icon-color-fix">unfold_less</mat-icon>
        </button>
        <button aria-label="Expand All" [disabled]="Tree_Response_State === -3" class="btn btn-sm button-fix button-color-fix-orange " (click)="longTreeExpandAll()">
          <mat-icon class="icon-color-fix">unfold_more</mat-icon>
        </button>
      </div>
    }

  </div>

  @if (showData) {
    <div class="custom_small_panelbody_fix">
      @if ((Tree_Response_State=== 1 && isExpanded===false)) {
        <div>
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
            <!-- This is the tree node template for leaf nodes -->
            <mat-nested-tree-node class="mat-tree-node" *matTreeNodeDef="let node"
              matTreeNodeToggle
              [style.display]="showOnlySelected && !node.selected || this.searchString && hideLeafNode(node) ? 'none' : 'block'">
              <li class="mat-tree-node">
                <mat-checkbox class="checklist-leaf-node" (change)="itemToggle($event.checked,node,true)" [disabled]="node.disabled" [checked]="node.selected">{{node.groupName}} </mat-checkbox>
              </li>
            </mat-nested-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
              [style.display]="(showOnlySelected && !(node.selected || node.indeterminate)) || this.searchString && hideParentNode(node) ? 'none' : 'block'">
              <li>
                <div class="mat-tree-node">
                  <button mat-icon-button matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.groupName" (click)="expandTriggered(node.groupName)">
                    <mat-icon class="mat-icon-rtl-mirror icon-color-fix">
                      chevron_right
                    </mat-icon>
                  </button>
                  <mat-checkbox [checked]="node.selected" [disabled]="node.disabled"
                    [indeterminate]="node.indeterminate && !node.selected"
                  (change)="itemToggle($event.checked,node,true)">{{node.groupName}}</mat-checkbox>
                </div>
                <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                  <ng-container matTreeNodeOutlet></ng-container>
                </ul>
              </li>
            </mat-nested-tree-node>
          </mat-tree>
        </div>
      }
      @if ((Tree_Response_State=== 1 && isExpanded===true)) {
        <div>
          <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
            <!-- This is the tree node template for leaf nodes -->
            <mat-nested-tree-node class="mat-tree-node" *matTreeNodeDef="let node"
              matTreeNodeToggle
              [style.display]="showOnlySelected && !node.selected || this.searchString && hideLeafNode(node) ? 'none' : 'block'">
              <li class="mat-tree-node">
                <mat-checkbox class="checklist-leaf-node" (change)="itemToggle($event.checked,node,true)" [disabled]="node.disabled" [checked]="node.selected">{{node.groupName}} </mat-checkbox>
              </li>
            </mat-nested-tree-node>
            <!-- This is the tree node template for expandable nodes -->
            <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild"
              [style.display]="(showOnlySelected && !(node.selected || node.indeterminate)) || this.searchString && hideParentNode(node) ? 'none' : 'block'">
              <li>
                <div class="mat-tree-node">
                  <button mat-icon-button matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.groupName">
                    <mat-icon class="mat-icon-rtl-mirror">
                      {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                    </mat-icon>
                  </button>
                  <mat-checkbox [checked]="node.selected" [disabled]="node.disabled"
                    [indeterminate]="node.indeterminate && !node.selected"
                  (change)="itemToggle($event.checked,node,true)">{{node.groupName}}</mat-checkbox>
                </div>
                <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                  <ng-container matTreeNodeOutlet></ng-container>
                </ul>
              </li>
            </mat-nested-tree-node>
          </mat-tree>
        </div>
      }
      @if (Tree_Response_State===-2) {
        <div style=" padding: 20px !important;">
          <div class="blackbg card__desc">
            @for (_ of [].constructor(4); track _) {
              <div class="card__desc-text"></div>
            }
          </div>
        </div>
      }
      <!-- Retry overlay with informative message -->
      @if (Tree_Response_State===-3) {
        <div class="retry-overlay">
          <div class="retry-overlay-content">
            <mat-spinner diameter="50" class="retry-spinner"></mat-spinner>
            <h4 class="retry-title">
              Applying changes...
            </h4>
            <p class="retry-message">
              DataAnalytics hierarchy changes may take a moment to appear
            </p>
            <p class="retry-submessage">
              <mat-icon class="retry-icon">schedule</mat-icon>
              Please wait while we sync with Azure
            </p>
          </div>
        </div>
      }
    </div>
  }
  <!--<div class="panel-body">
  <button  (click)="submit()" type="submit" class="btn button-color-fix pull-right">
    Save
    <mat-icon class="icon-color-fix">add</mat-icon>
  </button>
</div>-->
</div>
